// Produto Detalhe Page JavaScript
document.addEventListener('DOMContentLoaded', function() {
    console.log('Produto Detalhe page loaded');

    // Initialize Swiper Gallery
    initializeProductGallery();

    toggleOptionalCard();

    // Smooth scrolling for navigation links
    const navLinks = document.querySelectorAll('.produto-detalhe-hero__nav-link');
    navLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            const href = this.getAttribute('href');
            if (href && href !== '#') {
                // Allow normal navigation for external links
                return;
            }
            e.preventDefault();

            // Smooth scroll to section
            const targetId = this.getAttribute('href').substring(1);
            const targetSection = document.getElementById(targetId);
            if (targetSection) {
                targetSection.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    });

    // Intersection Observer for animations
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver(function(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.style.opacity = '1';
                entry.target.style.transform = 'translateY(0)';
            }
        });
    }, observerOptions);

    // Observe elements for animation
    const animatedElements = document.querySelectorAll('.produto-detalhe-content__title, .produto-detalhe-content__description');
    animatedElements.forEach(el => {
        el.style.opacity = '0';
        el.style.transform = 'translateY(30px)';
        el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
        observer.observe(el);
    });

    // Hero section parallax effect
    const heroSection = document.querySelector('.produto-detalhe-hero');
    if (heroSection) {
        window.addEventListener('scroll', function() {
            const scrolled = window.pageYOffset;
            const rate = scrolled * -0.5;
            const heroImage = heroSection.querySelector('.produto-detalhe-hero__image');
            if (heroImage) {
                heroImage.style.transform = `translateY(${rate}px)`;
            }
        });
    }
});

// Initialize Product Gallery with Swiper
function initializeProductGallery() {
    // Check if Swiper is loaded
    if (typeof Swiper === 'undefined') {
        console.warn('Swiper not loaded, loading from CDN...');
        loadSwiperFromCDN().then(() => {
            initializeSwiper();
        });
    } else {
        initializeSwiper();
    }
}

// Load Swiper from CDN if not already loaded
function loadSwiperFromCDN() {
    return new Promise((resolve, reject) => {
        // Check if Swiper CSS is already loaded
        if (!document.querySelector('link[href*="swiper"]')) {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
            document.head.appendChild(link);
        }

        // Check if Swiper JS is already loaded
        if (typeof Swiper === 'undefined') {
            const script = document.createElement('script');
            script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
            script.onload = resolve;
            script.onerror = reject;
            document.head.appendChild(script);
        } else {
            resolve();
        }
    });
}

// Initialize Swiper instances
function initializeSwiper() {
    // Thumbnail swiper
    const thumbsSwiper = new Swiper(".produto-gallery-thumbs", {
        slidesPerView: 4,
        loop: false,
        spaceBetween: 12,
        freeMode: true,
        watchSlidesProgress: true,
    });

    // Main swiper
    const mainSwiper = new Swiper(".produto-gallery-main", {
        slidesPerView: 1,
        loop: true,
        spaceBetween: 10,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        thumbs: {
            swiper: thumbsSwiper,
        },
        keyboard: {
            enabled: true,
        },
        // autoplay: {
        //     delay: 5000,
        //     disableOnInteraction: false,
        // },
    });

    // Add touch/swipe support for mobile
    if (window.innerWidth <= 768) {
        mainSwiper.allowTouchMove = true;
        thumbsSwiper.allowTouchMove = true;
    }

    // Add keyboard navigation
    document.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft') {
            mainSwiper.slidePrev();
        } else if (e.key === 'ArrowRight') {
            mainSwiper.slideNext();
        }
    });

    console.log('Product gallery Swiper initialized');
}

function toggleOptionalCard() {
    let card = document.querySelector('.produto-specifications__optional');
    let screen1 = card.querySelector('.collapsed');
    let screen2 = card.querySelector('.not-collapsed');
    let btnShow = screen1.querySelector('#btnShowNotColapsed');
    let btnHide = screen2.querySelector('#btnShowColapsed');

    btnShow.addEventListener('click', function() {
        screen1.classList.add('hidden');
        screen2.classList.remove('hidden');

        card.classList.add('expanded')
    });
    
    btnHide.addEventListener('click', function() {
        screen2.classList.add('hidden');
        screen1.classList.remove('hidden');

        card.classList.remove('expanded')
    })
}